export default "__VITE_ASSET__BtIwQiSK__"